import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  MenuItem,
  Paper,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import InputFormat from "../../../partials/inputForm";
import LabelForm from "../../../partials/labelForm";
import { getNumberOnString } from "../../../partials/validateNumber";
import DescriptionComponent from "../../descriptionComponent";
import InputFileReader from "../../fileReader";
import Loading from "../../loading";
import NumberFormatCustom from "../../numberFormat";
import SelectedBranch from "../../selectedBranch";
import Snackbar from "../../snackbar";
import { styles } from "./styles";

class CreateMemberCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      colorSnackbar: "",
      memberCard: {
        title: "",
        price: 0,
        value: 0,
        imgURL: "",
        shortDescription: "",
        description: "",
        expiredDays: "",
        times: "",
        isShow: 1,
        forAll: 0,
        type: "limited_all",
      },
      selectedBranch: [],
    };
    this.imgURL = "";
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUploadImage = this.handleUploadImage.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
    this.changeArrBranch = this.changeArrBranch.bind(this);
  }

  handleOpenSnackBar = (message, type = "success") => {
    this.mSnackbar.handleClick(message, type);
  };

  handleChange = (e) => {
    let value = e.target.value;
    let name = e.target.name;
    if (e.target.type === "checkbox") {
      value = e.target.checked ? 1 : 0;
    }
    if (
      name === "expiredDays" ||
      name === "times" ||
      name === "value" ||
      name === "price"
    )
      value = getNumberOnString(value);
    let memberCard = this.state.memberCard;
    memberCard[name] = value;
    this.setState({ memberCard });
  };

  handleSubComponentChange = (name, value) => {
    let memberCard = this.state.memberCard;
    memberCard[name] = value;
    this.setState({ memberCard });
  };

  async handleSubmit(imgURL = null) {
    let { t } = this.props;
    const _this = this;
    let arrBranch = this.state.selectedBranch;
    let check = await this.props.create(
      Object.assign(
        this.state.memberCard,
        { image: imgURL },
        { arrBranch: arrBranch }
      )
    );
    this.loading.stopLoading();
    if (check.code === 1) {
      this.handleOpenSnackBar(t("membercard_add_create_successfully"));
      if (_this.props.createDone) {
        setTimeout(function () {
          _this.props.createDone("success");
        }, 1000);
      }
    } else {
      this.handleOpenSnackBar(check.message, "warning");
    }
  }

  async handleUploadImage() {
    this.loading.startLoading();
    let t = this.props;
    if (this.InputFileReader.getFile() !== null) {
      let check = await this.props.uploadDispatch.saveStorage({
        files: this.InputFileReader.getFile(),
        code: this.props.serviceCode,
        imgPre: "",
        type: "img-member-card",
      });
      if (check.code === 1) this.handleSubmit(check.data.previewLink);
      else {
        this.handleOpenSnackBar(check.message, "warning");
        this.handleSubmit();
      }
    } else if (this.InputFileReader.getSrc() !== null) {
      this.handleSubmit(this.InputFileReader.getSrc());
    } else {
      this.handleSubmit();
    }
  }

  changeArrBranch(arrBranch) {
    this.setState({ selectedBranch: arrBranch });
  }

  handleCheck() {
    let memberCard = this.state.memberCard;
    let { t } = this.props;
    if (!memberCard.title)
      this.mSnackbar.handleClick(
        t("membercard_add_please_add_title"),
        "warning"
      );
    else if (!this.state.selectedBranch.length && memberCard.forAll == 0)
      this.mSnackbar.handleClick(
        t("membercard_add_nothing_apply_branch"),
        "warning"
      );
    else if (!memberCard.price)
      this.mSnackbar.handleClick(
        t("membercard_add_please_add_price_value"),
        "warning"
      );
    else if (
      (memberCard.type === "limited_all" &&
        (!memberCard.value || !memberCard.times)) ||
      (memberCard.type === "limited_times" && !memberCard.times) ||
      (memberCard.type === "limited_money" && !memberCard.value)
    ) {
      this.mSnackbar.handleClick(
        t("membercard_add_please_fill_in_required"),
        "warning"
      );
    } else this.handleUploadImage();
  }
  render() {
    const { classes, theme, t } = this.props;
    const { memberCard = {} } = this.state;
    // const { infoServiceBranch } = this.props.serviceBranchState;
    return (
      <Paper className={classes.root}>
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Loading onRef={(id) => (this.loading = id)} />
        <form className={classes.container} noValidate autoComplete="off">
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12}>
              <InputFormat
                label={t("membercard_add_title")}
                name="title"
                fullWidth={true}
                required
                value={memberCard.title}
                onChange={this.handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputFormat
                required
                label={t("type")}
                name="type"
                select
                fullWidth={true}
                value={memberCard.type}
                onChange={this.handleChange}
              >
                <MenuItem value={"limited_all"}>{t("limited_all")}</MenuItem>
                <MenuItem value={"limited_money"}>
                  {t("limited_money")}
                </MenuItem>
                <MenuItem value={"limited_times"}>
                  {t("limited_times")}
                </MenuItem>
                <MenuItem value={"unlimited_all"}>
                  {t("unlimited_all")}
                </MenuItem>
              </InputFormat>
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputFormat
                disabled={memberCard.type === "unlimited_all" ? true : false}
                required={
                  memberCard.type === "limited_times" ||
                  memberCard.type === "limited_all"
                    ? true
                    : false
                }
                label={t("membercard_add_times")}
                name="times"
                // type={'number'}
                fullWidth={true}
                value={memberCard.times}
                onChange={this.handleChange}
                // InputProps={{
                //     inputComponent: NumberFormatCustom,
                // }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputFormat
                label={t("membercard_add_price")}
                name="price"
                fullWidth={true}
                required
                value={memberCard.price}
                onChange={this.handleChange}
                InputProps={{
                  inputComponent: NumberFormatCustom,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputFormat
                disabled={memberCard.type === "unlimited_all" ? true : false}
                required={
                  memberCard.type === "limited_money" ||
                  memberCard.type === "limited_all"
                    ? true
                    : false
                }
                label={t("membercard_add_value")}
                name="value"
                value={memberCard.value}
                fullWidth={true}
                onChange={this.handleChange}
                inputProps={{
                  name: "value",
                }}
                InputProps={{
                  inputComponent: NumberFormatCustom,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputFormat
                label={t("membercard_add_expiredDays")}
                name="expiredDays"
                fullWidth={true}
                value={memberCard.expiredDays}
                onChange={this.handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputFormat
                select
                label={t("membercard_add_isShow")}
                placeholder={t("pls_select")}
                fullWidth={true}
                value={memberCard.isShow || 0}
                onChange={this.handleChange}
                name="isShow"
              >
                <MenuItem value={1}>{t("membercard_add_show")}</MenuItem>
                <MenuItem value={0}>{t("membercard_add_hide")}</MenuItem>
              </InputFormat>
            </Grid>
            {!memberCard.forAll ? (
              <Grid item xs={12} sm={12}>
                <SelectedBranch
                  onRef={(id) => (this.SelectedBranch = id)}
                  multiple={true}
                  required={true}
                  handleChangeBranch={this.changeArrBranch}
                  disabled={memberCard.forAll == 1}
                  value={this.state.selectedBranch}
                />
              </Grid>
            ) : (
              ""
            )}
            <Grid item xs={12} sm={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={memberCard.forAll == 1 ? true : false}
                    name="forAll"
                    onChange={this.handleChange}
                  />
                }
                className={classes.label}
                label={t("membercard_add_all_branch")}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <InputFormat
                label={t("membercard_add_shortDescription")}
                name="shortDescription"
                value={memberCard.shortDescription}
                onChange={this.handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <DescriptionComponent
                onRef={(id) => (this.DescriptionComponent = id)}
                title={t("membercard_add_description")}
                handleSubComponentChange={this.handleSubComponentChange}
                description={memberCard.description}
                spacing={3}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} style={{ paddingBottom: "0" }}>
              <LabelForm label={t("membercard_add_image")} />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl>
                <InputFileReader
                  onRef={(id) => (this.InputFileReader = id)}
                  style={classes}
                  container="square"
                  selectStorageMode={true}
                />
              </FormControl>
            </Grid>
          </Grid>

          <Grid container justify="flex-end" className={classes.marginTop}>
            <Button
              variant="contained"
              color="primary"
              // onClick={() => infoServiceBranch.branchCode ? this.handleCheck(infoServiceBranch.branchCode) : this.handleCheck()}
              onClick={this.handleCheck}
              className={classes.button}
            >
              {t("membercard_add_save")}
            </Button>
          </Grid>
        </form>
      </Paper>
    );
  }
}

CreateMemberCard.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  serviceCode: state.user.user.roleId.serviceCode,
  currencyCode: state.setting.setting
    ? state.setting.setting.currencyCode
    : "VND",
  serviceBranchState: state.serviceBranch,
});

const mapDispatch = (dispatch) => ({
  uploadDispatch: dispatch.upload,
  create: dispatch.memberCards.create,
  // serviceDispatch : dispatch.service,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(CreateMemberCard)
  )
);
